import { Trans } from '@lingui/react/macro';
import { X } from '@remarkable/ark-icons';
import { getRouteApi } from '@tanstack/react-router';

import {
  SubscriptionCancellationFlowExited,
  SubscriptionCancellationFlowStarted,
} from 'src/ampli';
import { tracker } from 'src/analytics/tracker';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { useCancelCloudConnectSubscription } from 'src/api/queries';
import { Button, Modal } from 'src/components';

import { CancelConnectModal } from './CancelConnectModal';

const routeApi = getRouteApi('/_auth/_layout/subscriptions/plan');

export const CloudConnectCancelSubscriptionButton = () => {
  const search = routeApi.useSearch();
  const navigate = routeApi.useNavigate();
  const cancelSubscription = useCancelCloudConnectSubscription();

  return (
    <Modal.Root
      onOpenChange={(open) => {
        if (open) {
          tracker.trackEvent(
            new SubscriptionCancellationFlowStarted({
              component_location:
                ComponentLocations.MANAGE_CONNECT.SUBSCRIPTION_PAGE,
              total_steps: 1,
            })
          );
          void navigate({ search: { cancel_subscription: 'confirm' } });
        } else {
          if (search.cancel_subscription === 'confirm') {
            tracker.trackEvent(
              new SubscriptionCancellationFlowExited({
                component_location: ComponentLocations.MRF_MODAL.MRF_MODAL,
                total_steps: 1,
                step_number: 1,
              })
            );
          }

          void navigate({ search: { cancel_subscription: undefined } });
        }
      }}
      open={
        search.cancel_subscription !== undefined &&
        search.cancel_subscription !== 'confirmation'
      }
    >
      <Modal.Trigger asChild>
        <Button
          size="large"
          variant="tertiary-neutral"
          className="w-full ls:w-fit"
          data-cy="cancel-subscription"
          analytics={{
            text: 'Cancel subscription',
            location: ComponentLocations.MANAGE_CONNECT.SUBSCRIPTION_PAGE,
            action: 'open cancel subscription flow',
          }}
        >
          <X />
          <span>
            <Trans>Cancel subscription</Trans>
          </span>
        </Button>
      </Modal.Trigger>

      <CancelConnectModal
        isCancelling={cancelSubscription.isPending}
        cancelError={cancelSubscription.error}
        onCancel={(onSuccess) => {
          cancelSubscription.mutate(undefined, { onSuccess });
        }}
      />
    </Modal.Root>
  );
};
